import _ from 'lodash';
import moment from 'moment';
import OSS from 'ali-oss';
// import '../../../style/index.css'
export default {
  install (Vue) {
    class OssUpload extends Vue {
      stsSignature = {
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        endpoint: '',
        stsToken: '',
        secure: true
      }

      getFileName (file) {
        if (!file.name) return false;
        let i = file.name.indexOf('.');
        if (i === -1) return false;
        return {
          suffix: file.name.substring(i, file.name.length),
          name: file.name.substring(0, i)
        };
      }

      uploading ({ file, name, suffix, beforeFilePath, stsSignature }) {
        try {
          const fileName = this.getFileName(file);
          if (fileName.suffix) {
            suffix = fileName.suffix;
          }
          if (!name && fileName.name) {
            name = fileName.name;
          }
        } catch (error) {
          console.log(error);
        }

        let dataArr = `${beforeFilePath || ''}${name || ''}-${moment().format('YYYY-MM-DD HH_mm_ss')}${suffix}`;
        let client = new OSS(stsSignature || this.stsSignature);
        return new Promise((resolve, reject) => {
          client.multipartUpload(dataArr, file).then(result => {
            try {
              result.url = result.res.requestUrls[0].split('?')[0];
              if (_.isArray(_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS)) {
                _.forEach(_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS, item => {
                  let regEx = new RegExp(`^${item[0].replace(/\./g, '\\.')}/`, 'i');
                  if (regEx.test(result.url)) {
                    result.url = result.url.replace(regEx, `${item[1] || _APP_.FILE_ADDRESS}/`);
                    return false;
                  }
                });
              } else {
                result.url = result.url.replace(
                  new RegExp(`^${_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS.replace(/\./g, '\\.')}/`, 'i'),
                  `${_APP_.FILE_ADDRESS}/`);
              }
              resolve(result);
            } catch (error) {
              reject(error);
            }
          }).catch(err => {
            reject(err);
          });
        });
      }


      /**
       *
       * @param {*file文件，name文件上传名称默认以源文件名称，suffix文件尾缀默认以源文件为主} {file, name, suffix = ''}
       * @returns
       * @memberof OssUpload
       */
      upload ({ file, name, suffix = '', beforeFilePath = '' }) {
        return new Promise((resolve, reject) => {
          let succ = res => {
            let data = res.data.data;
            data.secure = true;
            // data.endpoint = location.protocol + '//oss-cn-hangzhou.aliyuncs.com'
            data.endpoint = data.endpoint || data.endPoint;
            this.stsSignature = data;
            this.uploading({ file, name, suffix, beforeFilePath }).then(result => {
              resolve(result);
            }).catch(error => {
              reject(error);
            });
          };
          let fail = res => {
            reject(res);
          };
          this.$request.httpRequest({
            path: '/stsAuth/getByPolicy.do',
            data: {
              policy: 1
            },
            method: 'GET',
            succ,
            fail,
            baseURL: this.$env.systembiz,
            isEncode: false,
            platformKey: 'api'
          });
        });
      }

      uploadShanghai ({ file, name, suffix = '', beforeFilePath = '' }) {
        return new Promise((resolve, reject) => {
          let succ = res => {
            let data = res.data.data;
            data.secure = true;
            // data.endpoint = location.protocol + '//oss-cn-shanghai.aliyuncs.com'
            // data.endpoint = 'oss-cn-shanghai.aliyuncs.com'
            data.endpoint = data.endpoint || data.endPoint;
            // data.region = 'oss-cn-shanghai';
            // data.bucket = 'duobaoyu-shanghai'
            // data.cname = true;
            this.stsSignature = data;
            this.uploading({ file, name, suffix, beforeFilePath, stsSignature: data }).then(result => {
              resolve(result);
            }).catch(error => {
              reject(error);
            });
          };
          let fail = res => {
            reject(res);
          };
          this.$request.httpRequest({
            path: '/stsAuth/outer/ignore/getByPolicy',
            data: {
              policy: 1
            },
            method: 'GET',
            succ,
            fail,
            baseURL: this.$env.filecenter,
            isEncode: false,
            platformKey: 'api'
          });
        });
      }

      uploadingDomJson ({ file, belongId, sortId }) {
        let dataArr = `belongid/${belongId}/${sortId}.txt`;
        let client = new OSS(this.stsSignature);
        return new Promise((resolve, reject) => {
          client.multipartUpload(dataArr, file).then(result => {
            try {
              result.url = result.res.requestUrls[0].split('?')[0];
              resolve(result);
            } catch (error) {
              reject(error);
            }
          }).catch(err => {
            console.log('multipartUploadcatch');
            reject(err);
          });
        });
      }


      /**
       *
       */
      uploadDomJson ({ file, belongId, sortId }) {
        return new Promise((resolve, reject) => {
          if (this.stsSignature && this.stsSignature.invalidTime && new Date(this.stsSignature.invalidTime.replace('T', ' ').replace(/\.\d*$/, '')) > (new Date() + 600000)) {
            this.uploadingDomJson({ file, belongId, sortId }).then(res => {
              resolve(res);
            }).catch(error => {
              reject(error);
            });
          } else {
            let succ = res => {
              let data = res.data.data;
              data.secure = true;
              data.endpoint = '91duobaoyu.com';
              this.stsSignature = data;
              this.uploadingDomJson({ file, belongId, sortId }).then(result => {
                resolve(result);
              }).catch(error => {
                reject(error);
              });
            };
            let fail = res => {
              reject(res);
            };
            this.$request.httpRequest({
              path: '/stsAuth/outer/ignore/getByPolicyBusinessCode?policy=1&businessCode=recall',
              data: {
                policy: 1,
                businessCode: 'recall'
              },
              method: 'POST',
              succ,
              fail,
              baseURL: this.$env.filecenter,
              isEncode: false,
              platformKey: 'api'
            });
          }
        });
      }

      dataURLtoBlob(dataurl) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]); let n = bstr.length; let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
      }

      updateBase64(base64, name = '', suffix) {
        const file = this.dataURLtoBlob(base64);
        return new Promise((resolve, reject) => {
          let succ = res => {
            let data = res.data.data;
            data.secure = true;
            data.endpoint = data.endpoint || data.endPoint;
            this.stsSignature = data;
            let dataArr = `${name}${moment().format('YYYY-MM-DD HH_mm_ss')}${suffix}`;
            let client = new OSS(this.stsSignature);
            client.multipartUpload(dataArr, file).then(result => {
              try {
                result.url = result.res.requestUrls[0].split('?')[0];
                if (_.isArray(_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS)) {
                  _.forEach(_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS, item => {
                    let regEx = new RegExp(`^${item[0].replace(/\./g, '\\.')}/`, 'i');
                    if (regEx.test(result.url)) {
                      result.url = result.url.replace(regEx, `${item[1] || _APP_.FILE_ADDRESS}/`);
                      return false;
                    }
                  });
                } else {
                  result.url = result.url.replace(
                    new RegExp(`^${_APP_.ORIGIN_ADDRESSES.FILE_ADDRESS.replace(/\./g, '\\.')}/`, 'i'),
                    `${_APP_.FILE_ADDRESS}/`);
                }
                resolve(result);
              } catch (error) {
                reject(error);
              }
            }).catch(err => {
              reject(err);
            });
          };
          let fail = res => {
            this.message.error('后台出错了！');
            reject(res);
          };
          this.$request.httpRequest({
            path: '/stsAuth/getByPolicy.do',
            data: {
              policy: 1
            },
            method: 'GET',
            succ,
            fail,
            baseURL: this.$env.systembiz,
            isEncode: false,
            platformKey: 'api'
          });
        });
      }
    }
    Vue.prototype.$ossUpload = new OssUpload();
  }
};
